const RegisterTabKey = Symbol();
const UnregisterTabKey = Symbol();
const ActiveTabHashKey = Symbol();

export { ActiveTabHashKey, RegisterTabKey, UnregisterTabKey };
